<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M28 6.476v2.38c0 2.099-5.375 3.81-12 3.81S4 10.955 4 8.856v-2.38c0-2.099 5.375-3.81 12-3.81s12 1.711 12 3.81zm0 5.357v5.357C28 19.288 22.625 21 16 21S4 19.287 4 17.19v-5.357c2.578 1.726 7.297 2.53 12 2.53s9.422-.804 12-2.53zm0 8.333v5.357c0 2.098-5.375 3.81-12 3.81S4 27.62 4 25.523v-5.357c2.578 1.726 7.297 2.53 12 2.53s9.422-.804 12-2.53z"/></svg>
</template>

<script>
export default {
  name: 'serverDatabaseFilled'
}
</script>
